import { CardBrand } from '@/app/shared/enums';
import { Model } from '@/app/shared/models/model';

export class CreditModel extends Model {
  public CardExpiration!: string;
  public CardHolder!: string;
  public CardKey!: string;
  public CardTruncatedNumber!: string;
  public CardBrand!: CardBrand;

  constructor() {
    super();
    this.CardTruncatedNumber = '';
    this.CardExpiration = '';
    this.CardKey = '';
  }
}
